// Eigenbau: Markdown-Leseansicht des Aufgabeninhalts über die vorhandene
// SeitenLeseansicht — Tremor hat dafür keinen Baustein.
import { SeitenLeseansicht } from "@/components/seiten/SeitenLeseansicht";

type Eigenschaften = {
  inhalt: string;
};

/** Rendert den als Markdown gespeicherten Aufgabeninhalt in der Leseansicht. */
export function AufgabenBeschreibung({ inhalt }: Eigenschaften) {
  if (!inhalt.trim()) {
    return (
      <p className="max-w-[62ch] text-[15.5px] font-light leading-[1.7] text-tinte2">
        Noch keine Beschreibung.
      </p>
    );
  }

  return (
    <SeitenLeseansicht
      markdown={inhalt}
      className="aufgabe-beschreibung max-w-[62ch]"
    />
  );
}
